const config = {
  Host: '/api',
  APP_ID: process.env.APP_ID,
  WS_HOST: process.env.WS_HOST,
};
export default config;
